import React from 'react'
import './style.module.scss'
import { Pagination } from 'antd'
import classNames from 'classnames'

function PointProgress({ questions = [], index, skip, answers = [] }) {
  console.log("🚀 ~ file: PointProgress.jsx ~ line 6 ~ PointProgress ~ questions", questions.length)
  return (
    <div className='PointProgress'>
      <Pagination 
        defaultCurrent={index + 1} 
        current={index + 1} 
        total={questions.length}
        defaultPageSize={1}
        onChange={(page) => {
          skip(page-1)
          console.log("🚀 ~ file: PointProgress.jsx ~ line 16 ~ PointProgress ~ page", page)
        }}
        itemRender={(page, type, el) => type == 'prev' || type == 'next' ? el : <div className={classNames('point', {isTrue: answers[page-1] === true, isFalse: answers[page-1] === false})}></div>} 
      />
    </div>
  )
}

export default PointProgress


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/PointProgress/PointProgress.jsx